export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavTitle',
        _children: ['Report']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Order',
        to: '/report/order-list',
        icon: 'cil-cart'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Transaction',
        to: '/report/transaction-list',
        icon: 'cil-list'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Collaboration Request',
        to: '/report/collaboration-request',
        icon: 'cil-list'
      },
      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Product']
      },
      {
        _name: 'CSidebarNavItem',
        name: ' Product',
        to: '/product/list',
        icon: 'cil-flower',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Category',
        to: '/product/category',
        icon: 'cil-layers',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Color',
        to: '/product/color',
        icon: 'cil-color-palette',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Occasion',
        to: '/product/occasion',
        icon: 'cil-heart',
      },
      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['Option']
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Configuration',
        route: '/config',
        icon: 'cil-settings',
        items: [
          {
            name: 'City',
            to: '/config/city',
          },
          {
            name: 'About Us',
            to: '/config/about-us'
          },
          {
            name: 'Announcement',
            to: '/config/announcement'
          },
          {
            name: 'Notification',
            to: '/config/notification'
          },
          {
            name: 'Home - Banners',
            to: '/config/banners'
          },
          {
            name: 'Home - Showcase',
            to: '/config/showcase'
          },
          {
            name: 'Featured Products',
            to: '/config/featured-products'
          },
          {
            name: 'Terms and Condition',
            to: '/config/tnc'
          },
        ]
      },
    ]
  }
]